import React, { useEffect } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./notAuthorized.css";
import { ArrowLeftOutlined } from "@ant-design/icons";

const NotAuthorized = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(generateLocks, 500);
    generateLocks();

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const generateLocks = () => {
    const lock = document.createElement("div");
    lock.innerHTML = '<div class="top"></div><div class="bottom"></div>';
    lock.className = "lock";
    const [x, y] = generatePosition();
    lock.style.top = x;
    lock.style.left = y;
    document.body.appendChild(lock);
    setTimeout(() => {
      lock.style.opacity = "1";
      lock.classList.add("generated");
    }, 100);
    setTimeout(() => {
      lock.remove();
    }, 2000);
  };

  const generatePosition = () => {
    const x = Math.round(Math.random() * 100 - 10) + "%";
    const y = Math.round(Math.random() * 100) + "%";
    return [x, y];
  };

  return (
    <div className="container">
      <h1 className="font-semibold">403</h1>
      <p className="font-semibold">
        You don’t have permission to access this page.
      </p>
      <Button
        size="large"
        type="primary"
        icon={<ArrowLeftOutlined />}
        style={{
          marginTop: "40px", // very slight spacing
          backgroundColor: "#80EF80",
          borderColor: "#80EF80",
          color: "black",
        }}
        onClick={() => navigate(-1)}
      >
        Go Back
      </Button>
      <div className="lock">
        <div className="top"></div>
        <div className="bottom"></div>
      </div>
    </div>
  );
};

export default NotAuthorized;
